export default __webpack_public_path__ + "static/media/fanAnimation.65ae3e4e.gif";